export default "__VITE_ASSET__C1vrb6nx__"